import { useSlider } from '@hooks/useSlider';
import { ReactNode } from 'react';
import NavigationButtons from './NavigationButtons/NavigationButtons';
import SlideIndicators from './SlideIndicators/SlideIndicators';

import './Slider.css';

interface SliderProps {
	children: ReactNode[];
	hasNavigation?: boolean;
	hasIndicators?: boolean;
	autoPlayInterval?: number;
}

const Slider = ({ children, hasNavigation = true, hasIndicators = true, autoPlayInterval }: SliderProps) => {
	const slidesCount = children?.length;

	const { currentSlide, slidesContainerRef, handleSlideChange } = useSlider({
		slidesCount,
		autoPlayInterval
	});

	return (
		<div id="slider">
			<div className="slides-container" ref={slidesContainerRef}>
				{children}
			</div>
			{hasNavigation && <NavigationButtons currentSlide={currentSlide} totalSlides={slidesCount} onSlideChange={handleSlideChange} />}
			{hasIndicators && <SlideIndicators totalSlides={slidesCount} currentSlide={currentSlide} onSlideChange={handleSlideChange} />}
		</div>
	);
};

export default Slider;
